import { render, staticRenderFns } from "./GameSettingValue.vue?vue&type=template&id=690faa88&scoped=true&"
import script from "./GameSettingValue.vue?vue&type=script&lang=js&"
export * from "./GameSettingValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690faa88",
  null
  
)

export default component.exports